module.exports = __webpack_public_path__ + "img/sponsoring.1821964.png";